import { logger } from 'client/utils/logger/logger';

export const logVariables = (title, dataObj) => {
  const message = dataObj ? `${title}: ${JSON.stringify(dataObj)}` : title;
  logger.warn(message);
};
